//
// Approach Page Nav functions
//
export default class ApproachNav {
    constructor() {

        const approachNavElement = document.querySelector(".approach-nav");

        // Initialise Approach Nav JS if present, else quit out now
        if (!approachNavElement) return;

        //
        // Highlight currently active Section Nav
        //
        const sectionHeadings = document.querySelectorAll('.js-section-heading[id]');
        const sectionNavListItems = document.querySelectorAll('.js-approach-nav__list-item');

        // Only trigger the change when the next section heading enters 50% of the viewport height
        const sectionNavOptions = {
            rootMargin: '0px 0px -50%',
        }

        // Create an intersectionObserver for each section section nav heading
        const sectionNavHeadings = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const id = entry.target.getAttribute('id');

                // If the heading is visible on the page, trigger the event
                if (entry.intersectionRatio > 0) {
                    // Remove all other active classes
                    sectionNavListItems.forEach((listItem) => {
                        listItem.classList.remove('approach-nav__list-item--active');
                    });
                    // Add active class to current element
                    document.querySelector(`.js-approach-nav li a[href="#${id}"]`).parentElement.classList.add('approach-nav__list-item--active');
                }
            });
        }, sectionNavOptions);

        // Track all sections that have an `id` applied
        sectionHeadings.forEach((section) => {
            sectionNavHeadings.observe(section);
        });

        //
        // Sticky Nav Helper
        //
        // When the sticky nav is 'stuck' add a 'stuck' attribute to the sticky nav element
        const stickyNavObserver = new IntersectionObserver(
            ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
            {
                threshold: [1]
            }
        );
        stickyNavObserver.observe(approachNavElement);
    }
}